var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMenuLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 11.666L17.25 7.99935M17.25 7.99935L13.5833 4.33268M17.25 7.99935L4.41667 7.99935M9.91667 11.666V12.5827C9.91667 14.1015 8.68545 15.3327 7.16667 15.3327H3.5C1.98122 15.3327 0.75 14.1015 0.75 12.5827V3.41602C0.75 1.89723 1.98122 0.666016 3.5 0.666016H7.16667C8.68545 0.666016 9.91667 1.89723 9.91667 3.41602V4.33268",
    stroke: "#F32626",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuLogOut);
export default __webpack_public_path__ + "static/media/nav_menu_log_out.900c4d6dc4f6eee70516ae4f9657d50e.svg";
export { ForwardRef as ReactComponent };